// --- 运营管理 --- //

export default [
  {
    name: 'commodityRestriction',
    path: '/supplySystem/:supplyId/operationManagement/commodityRestriction',
    meta: { title: '商品限购' },
    component: require('business/supplySystem/operationManagement/commodityRestriction/list.vue').default
  },
  {
    name: 'restrictionTemplate',
    path: '/supplySystem/:supplyId/operationManagement/restrictionTemplate',
    meta: { title: '限购模版设置' },
    component: require('business/supplySystem/operationManagement/restrictionTemplate/list.vue').default
  },
  {
    name: 'promotionManage',
    path: '/supplySystem/:supplyId/operationManagement/promotionManage',
    meta: { title: '优惠活动' },
    component: require('business/supplySystem/operationManagement/promotionManage/list.vue').default
  },
  {
    name: 'promotionDetail',
    path: '/supplySystem/:supplyId/operationManagement/promotionManage/detail',
    meta: { title: '活动详情' },
    component: require('business/supplySystem/operationManagement/promotionManage/detail.vue').default
  }
]
